import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { PresetsCreate } from './PresetsCreate/PresetsCreate';
import { PresetsEdit } from './PresetsEdit/PresetsEdit';
import { PresetsList } from './PresetsList/PresetsList';
import { PresetsShow } from './PresetsShow/PresetsShow';

export const presetsResource: ResourceProps = {
  name: Resources.Presets,
  list: PresetsList,
  create: PresetsCreate,
  edit: PresetsEdit,
  show: PresetsShow,
};
